module.exports = __webpack_public_path__ + "img/MZ.34fc7685.svg";